<template>
  <section
    class="hero is-link is-fullheight-with-navbar"
    style="
      background-size: cover;
      background-position: center;
    "
    :style="{
      'background-image': 'url(' + dunes + ')'
    }"
  >
    <div class="hero-body">
      <div class="container">
        <div class="columns is-mobile is-centered is-multiline">
          <div class="column is-one-third-desktop is-column-flex">
            <box-apps
              :link="chewie"
              title="Chewie"
              color="dark"
              tags="Site, Offres, News, Candidatures"
              :icon="chewieIcon"
            />
          </div>
        </div>
        <div class="columns is-mobile is-centered is-multiline">
          <div
            class="column is-column-flex"
            v-for="app in apps"
            :key="app.title"
          >
            <box-apps
              :link="app.path"
              :title="app.title"
              :color="app.color"
              :tags="app.tags"
              :icon="app.icon"
            >
              <tooltip
                v-if="app.warningAuth"
                label="Une authentification sera nécessaire"
                type="is-dark"
              >
                <i class="fas fa-exclamation-circle has-text-white" />
              </tooltip>
            </box-apps>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import pinkDunes from "@/assets/pinkDunes.svg";
import BoxApps from "@/components/BoxApps";
import chewie from "@/assets/chewie.svg";
import intranet from "@/assets/intranet.svg";
import report from "@/assets/report.svg";
import activity from "@/assets/activity.svg";
import { Tooltip } from "buefy/src/components/tooltip";

const apps = [
  {
    title: "Intranet",
    icon: intranet,
    color: "success",
    tags: "Communications, Bonnes pratiques",
    path: process.env.VUE_APP_INTRA,
    warningAuth: true
  },
  {
    title: "RMM",
    icon: report,
    color: "teal",
    tags: "Reporting, Mission, Opportunités",
    path: process.env.VUE_APP_RMM,
    warningAuth: true
  },
  {
    title: "CRA",
    icon: activity,
    color: "red-dark",
    tags: "Facturation, Mission",
    path: process.env.VUE_APP_CRA,
    warningAuth: true
  },
  {
    title: "Adelle",
    icon: activity,
    color: "link",
    tags: "Clients, Organisations",
    path: process.env.VUE_APP_ADELLE,
    warningAuth: true
  }
];

export default {
  components: { BoxApps, Tooltip },
  data() {
    return {
      apps: apps,
      chewieIcon: chewie,
      dunes: pinkDunes,
      chewie: process.env.VUE_APP_CHEWIE
    };
  }
};
</script>

<style scoped lang="scss">
.container .columns:first-child {
  margin-bottom: 10rem;
}
</style>
